import _classCallCheck from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/Toolbar/toolbar';
import { css } from '@patternfly/react-styles';
import { ToolbarItem } from './ToolbarItem';
import { Button } from '../Button';
import { ToolbarGroup } from './ToolbarGroup';
import { globalBreakpoints } from './ToolbarUtils';
export var ToolbarChipGroupContent =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ToolbarChipGroupContent, _React$Component);

  function ToolbarChipGroupContent() {
    _classCallCheck(this, ToolbarChipGroupContent);

    return _possibleConstructorReturn(this, _getPrototypeOf(ToolbarChipGroupContent).apply(this, arguments));
  }

  _createClass(ToolbarChipGroupContent, [{
    key: "render",
    value: function render() {
      var _a = this.props,
          className = _a.className,
          isExpanded = _a.isExpanded,
          chipGroupContentRef = _a.chipGroupContentRef,
          clearAllFilters = _a.clearAllFilters,
          showClearFiltersButton = _a.showClearFiltersButton,
          clearFiltersButtonText = _a.clearFiltersButtonText,
          collapseListedFiltersBreakpoint = _a.collapseListedFiltersBreakpoint,
          numberOfFilters = _a.numberOfFilters,
          props = __rest(_a, ["className", "isExpanded", "chipGroupContentRef", "clearAllFilters", "showClearFiltersButton", "clearFiltersButtonText", "collapseListedFiltersBreakpoint", "numberOfFilters"]);

      var clearChipGroups = function clearChipGroups() {
        clearAllFilters();
      };

      var collapseListedFilters = typeof window !== 'undefined' ? window.innerWidth < globalBreakpoints[collapseListedFiltersBreakpoint] : false;
      return React.createElement("div", Object.assign({
        className: css(styles.toolbarContent, (numberOfFilters === 0 || isExpanded) && styles.modifiers.hidden, className)
      }, (numberOfFilters === 0 || isExpanded) && {
        hidden: true
      }, {
        ref: chipGroupContentRef
      }, props), React.createElement(ToolbarGroup, Object.assign({
        className: css(collapseListedFilters && styles.modifiers.hidden)
      }, collapseListedFilters && {
        hidden: true
      }, collapseListedFilters && {
        'aria-hidden': true
      })), collapseListedFilters && numberOfFilters > 0 && !isExpanded && React.createElement(ToolbarGroup, null, React.createElement(ToolbarItem, null, numberOfFilters, " filters applied")), showClearFiltersButton && !isExpanded && React.createElement(ToolbarItem, null, React.createElement(Button, {
        variant: "link",
        onClick: clearChipGroups,
        isInline: true
      }, clearFiltersButtonText)));
    }
  }]);

  return ToolbarChipGroupContent;
}(React.Component);
ToolbarChipGroupContent.defaultProps = {
  clearFiltersButtonText: 'Clear all filters',
  collapseListedFiltersBreakpoint: 'lg'
};